import {createAction, props} from '@ngrx/store';
import {Notification} from '../notification.model';

export const loadNotifications = createAction('[Notification] Load Notifications');
export const loadNotificationsSuccess = createAction('[Notification] Load Notifications Success', props<{
  notifications: Notification[]
}>());
export const loadNotificationsFailure = createAction('[Notification] Load Notifications Failure', props<{
  error: any
}>());

export const loadNotification = createAction('[Notification] Load Notification', props<{ id: number }>());
export const loadNotificationSuccess = createAction('[Notification] Load Notification Success', props<{
  notification: Notification
}>());
export const loadNotificationFailure = createAction('[Notification] Load Notification Failure', props<{
  error: any
}>());

export const updateNotification = createAction('[Notification] Update Notification', props<{
  id: number,
  read?: boolean,
  hide?: boolean
}>());

export const markNotificationAsRead = createAction(
  '[Notification] Mark Notification As Read',
  props<{ id: number }>()
);

export const markNotificationAsUnRead = createAction(
  '[Notification] Mark Notification As Unread',
  props<{ id: number }>()
);
export const hideNotification = createAction(
  '[Notification] Hide Notification',
  props<{ id: number }>()
);

export const updateNotificationSuccess = createAction(
  '[Notification] Update Notification Success',
  props<{ id: number; read?: boolean; hide?: boolean }>()
);


export const updateNotificationFailure = createAction('[Notification] Update Notification Failure', props<{
  error: any
}>());

export const openNotificationDetails = createAction(
  '[Notification] Open Notification Details',
  props<{ id: number; title: string; body: string }>()
);

